export const GET_COURIER_LIST_ITEMS = "GET_COURIER_LIST_ITEMS";
export const GET_COURIER_LIST_ITEM_BY_ID = "GET_COURIER_LIST_ITEM_BY_ID";
export const UPDATE_COURIER_LIST_ITEM = "UPDATE_COURIER_LIST_ITEM";
export const DELETE_COURIER_LIST_ITEM = "DELETE_COURIER_LIST_ITEM";
export const CREATE_COURIER_LIST_ITEM = "CREATE_COURIER_LIST_ITEM";
